package com.hyperether.goodjob.scenes.addNew

import androidx.compose.runtime.MutableState
import androidx.compose.runtime.derivedStateOf
import androidx.compose.runtime.mutableStateListOf
import androidx.compose.runtime.mutableStateOf
import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.hyperether.goodjob.getPlatformChecker
import com.hyperether.goodjob.models.Plan
import com.hyperether.goodjob.models.Role
import com.hyperether.goodjob.models.Site
import com.hyperether.goodjob.models.Skills
import com.hyperether.goodjob.models.Team
import com.hyperether.goodjob.models.User
import com.hyperether.goodjob.models.UserStatus
import com.hyperether.goodjob.models.UserTeam
import com.hyperether.goodjob.repository.Mapper
import com.hyperether.goodjob.repository.Repository
import com.hyperether.goodjob.repository.remote.model.ParsedAddress
import com.hyperether.goodjob.repository.remote.model.Resource
import com.hyperether.goodjob.repository.remote.model.WorkingHours
import com.hyperether.goodjob.resources.Res
import com.hyperether.goodjob.resources.email_required
import com.hyperether.goodjob.resources.error_employee_number
import com.hyperether.goodjob.resources.error_manager_number
import com.hyperether.goodjob.resources.role_required
import com.hyperether.goodjob.resources.status_required
import com.hyperether.goodjob.resources.unknown_error
import com.hyperether.resources.LocalizedStrings
import com.hyperether.resources.currentLanguage
import com.hyperether.resources.stringResourcePlain
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.first
import kotlinx.coroutines.launch
import org.jetbrains.compose.resources.StringResource
import org.lighthousegames.logging.logging

class AddUserViewModel(val repository: Repository) : ViewModel() {

    val log = logging("AddUserViewModel")

    /*Add new employee*/
    val fullNameInput: MutableState<String> = mutableStateOf("")
    val phoneInput: MutableState<String> = mutableStateOf("")
    val emailInput: MutableState<String> = mutableStateOf("")
    val zipInput: MutableState<String> = mutableStateOf("")
    val cityInput: MutableState<String> = mutableStateOf("")
    val countryInput: MutableState<String> = mutableStateOf("")
    val addressInput: MutableState<String> = mutableStateOf("")
    val status: MutableState<String> = mutableStateOf("")
    val roleSelected: MutableState<String> = mutableStateOf("")
    val sites = mutableStateListOf<Site>()

    private val _selectedSkills = MutableStateFlow<List<String>>(emptyList())
    val selectedSkills: StateFlow<List<String>> = _selectedSkills.asStateFlow()

    private val _availableSkills = MutableStateFlow<List<Skills>>(emptyList())
    val availableSkills: StateFlow<List<Skills>> = _availableSkills.asStateFlow()

    private val _teams = MutableStateFlow<List<Team>>(emptyList())
    val teams: StateFlow<List<Team>> = _teams
    var places = mutableStateListOf<ParsedAddress>()
    var place: ParsedAddress? = null


    val teamInput: MutableState<List<Team>> = mutableStateOf(emptyList())
    val upcomingLeaves: MutableState<String> = mutableStateOf("")

    private val _selectedUser = MutableStateFlow<User?>(null)
    val selectedUser: StateFlow<User?> = _selectedUser
    val remoteEmployee = mutableStateOf<User?>(null)


    /* Edit user */
    private val _preselectedSkills = MutableStateFlow<List<String>>(emptyList())
    val preselectedSkills: StateFlow<List<String>> = _preselectedSkills.asStateFlow()

    val isCalendar2Visible: MutableState<Boolean> = mutableStateOf(false)
    val showPopUpSuccess: MutableState<Boolean> = mutableStateOf(false)
    val showPopUpError: MutableState<Boolean> = mutableStateOf(false)
    val showLoader: MutableState<Boolean> = mutableStateOf(false)
    val errorText: MutableState<String> = mutableStateOf("")

    var roleMap: Map<String, String> = mutableMapOf()
    var userStatusMap: Map<String, String> = mutableMapOf()

    init {
        if (getPlatformChecker().isMobile()) {
            log.d("PricingViewModel") { "init isMobile: ${getPlatformChecker().isMobile()}" }
            init()
        }
    }

    fun init() {
        viewModelScope.launch {
            upcomingLeaves.value = ""
        }
        getAllTeamsRemote()
        getAllSkillsRemote()
    }

    fun getTeams() {
        viewModelScope.launch {
            repository.getTeamsFlow().collect {
                _teams.value = it
            }
        }
    }

    fun setPreselectedSkills(preselectedSkills: List<String>) {
        _preselectedSkills.value = preselectedSkills
    }

    fun setSelectedSkills(selectedSkills: List<String>) {
        _selectedSkills.value = selectedSkills
    }

    val showErrorDialog = mutableStateOf(false)

    val daysSchedule = listOf(
        DaySchedule(
            dayInt = 0,
            isChecked = mutableStateOf(true),
            startTime = mutableStateOf("08:00"),
            endTime = mutableStateOf("16:00"),
            isStartTimePickerVisible = mutableStateOf(false),
            isEndTimePickerVisible = mutableStateOf(false)
        ),
        DaySchedule(
            dayInt = 1,
            isChecked = mutableStateOf(true),
            startTime = mutableStateOf("08:00"),
            endTime = mutableStateOf("16:00"),
            isStartTimePickerVisible = mutableStateOf(false),
            isEndTimePickerVisible = mutableStateOf(false)
        ),
        DaySchedule(
            dayInt = 2,
            isChecked = mutableStateOf(true),
            startTime = mutableStateOf("08:00"),
            endTime = mutableStateOf("16:00"),
            isStartTimePickerVisible = mutableStateOf(false),
            isEndTimePickerVisible = mutableStateOf(false)
        ),
        DaySchedule(
            dayInt = 3,
            isChecked = mutableStateOf(true),
            startTime = mutableStateOf("08:00"),
            endTime = mutableStateOf("16:00"),
            isStartTimePickerVisible = mutableStateOf(false),
            isEndTimePickerVisible = mutableStateOf(false)
        ),
        DaySchedule(
            dayInt = 4,
            isChecked = mutableStateOf(true),
            startTime = mutableStateOf("08:00"),
            endTime = mutableStateOf("16:00"),
            isStartTimePickerVisible = mutableStateOf(false),
            isEndTimePickerVisible = mutableStateOf(false)
        ),
        DaySchedule(
            dayInt = 5,
            isChecked = mutableStateOf(false),
            startTime = mutableStateOf("08:00"),
            endTime = mutableStateOf("16:00"),
            isStartTimePickerVisible = mutableStateOf(false),
            isEndTimePickerVisible = mutableStateOf(false)
        ),
        DaySchedule(
            dayInt = 6,
            isChecked = mutableStateOf(false),
            startTime = mutableStateOf("08:00"),
            endTime = mutableStateOf("16:00"),
            isStartTimePickerVisible = mutableStateOf(false),
            isEndTimePickerVisible = mutableStateOf(false)
        )
    )

    val workingHours = derivedStateOf {
        WorkingHours(
            monday = daysSchedule.find { it.dayInt == 0 }?.toDayHours(),
            tuesday = daysSchedule.find { it.dayInt == 1 }?.toDayHours(),
            wednesday = daysSchedule.find { it.dayInt == 2 }?.toDayHours(),
            thursday = daysSchedule.find { it.dayInt == 3 }?.toDayHours(),
            friday = daysSchedule.find { it.dayInt == 4 }?.toDayHours(),
            saturday = daysSchedule.find { it.dayInt == 5 }?.toDayHours(),
            sunday = daysSchedule.find { it.dayInt == 6 }?.toDayHours()
        )
    }

    fun clearWorkingHours() {
        daysSchedule.forEach { day ->
            day.isChecked.value = day.dayInt <= 4
            day.startTime.value = "08:00"
            day.endTime.value = "16:00"
        }
    }

    fun addUser(onSuccess: () -> Unit, onError: () -> Unit) {
        val selectedRole = roleMap[roleSelected.value]
        validateRoleLimit(selectedRole) { roleError ->
            val errorMessage = when {
                roleSelected.value.isBlank() -> Res.string.role_required
                emailInput.value.isBlank() -> Res.string.email_required
                status.value.isBlank() -> Res.string.status_required
                roleError != null -> roleError
                else -> null
            }

            if (errorMessage != null) {
                viewModelScope.launch {
                    errorText.value = LocalizedStrings.get(errorMessage.key, currentLanguage.value)
                    onError()
                }
                return@validateRoleLimit
            }

            // If validation passes, create the employee object
            val user = User(
                fullName = fullNameInput.value,
                email = emailInput.value,
                address = addressInput.value,
                city = cityInput.value,
                zip = zipInput.value,
                country = countryInput.value,
                status = userStatusMap[status.value],
                teams = getUserTeam(),
                skills = selectedSkills.value,
                role = roleMap[roleSelected.value],
                phone = phoneInput.value,
                workspaceId = repository.getWorkspaceId(),
                upcomingLeave = upcomingLeaves.value,
                workingHours = workingHours.value,
                lang = currentLanguage.value.code
            )

            viewModelScope.launch {
                when (val result = repository.addUser(Mapper().toUserRequest(user))) {
                    is Resource.Success -> {
                        println("User added successfully")
                        clearUserValues()
                        onSuccess()
                    }

                    is Resource.Error -> {
                        println("Error while adding user")
                        errorText.value =
                            result.text ?: stringResourcePlain(Res.string.unknown_error)
                        onError()
                    }
                }
            }
        }
    }

    fun updateUser(onSuccess: () -> Unit, onError: () -> Unit) {
        val selectedRole = roleMap[roleSelected.value]
        val errorMessage = when {
            roleSelected.value.isBlank() -> Res.string.role_required
            emailInput.value.isBlank() -> Res.string.email_required
            status.value.isBlank() -> Res.string.status_required
            else -> null
        }

        if (errorMessage != null) {
            viewModelScope.launch {
                errorText.value = LocalizedStrings.get(errorMessage.key, currentLanguage.value)
                onError()
            }
            return
        }

        // If validation passes, create the employee object
        val user = User(
            fullName = fullNameInput.value,
            email = emailInput.value,
            address = addressInput.value,
            city = cityInput.value,
            zip = zipInput.value,
            country = countryInput.value,
            status = userStatusMap[status.value],
            teams = getUserTeam(),
            skills = selectedSkills.value,
            role = roleMap[roleSelected.value],
            phone = phoneInput.value,
            workspaceId = repository.getWorkspaceId(),
            upcomingLeave = upcomingLeaves.value,
            workingHours = workingHours.value,
            lang = currentLanguage.value.code
        )

        viewModelScope.launch {
            selectedUser.value?._id?.let {
                when (val result = repository.updateUser(it, Mapper().toUserRequest(user))) {
                    is Resource.Success -> {
                        println("User updated successfully")
                        clearUserValues()
                        onSuccess()
                    }

                    is Resource.Error -> {
                        println("Error while updating user")
                        errorText.value =
                            result.text ?: stringResourcePlain(Res.string.unknown_error)
                        onError()
                    }
                }
            }
        }
    }

    private fun getUserTeam(): List<UserTeam> {
        teamInput.value.let {
            return it.map { team -> UserTeam(id = team._id, value = team.name) }
        }
        return listOf()
    }

    fun clearUserValues() {
        viewModelScope.launch {
            fullNameInput.value = ""
            emailInput.value = ""
            addressInput.value = ""
            zipInput.value = ""
            countryInput.value = ""
            cityInput.value = ""
            status.value = ""
            phoneInput.value = ""
            upcomingLeaves.value = ""
            roleSelected.value = ""
            _selectedSkills.value = emptyList()
            _preselectedSkills.value = emptyList()
            teamInput.value = emptyList()
            clearWorkingHours()
            places.clear()
            place = null
        }
    }

    fun createTeam(name: String, onTeamCreated: (Team?) -> Unit) {
        viewModelScope.launch {
            when (val result = repository.createTeam(name)) {
                is Resource.Success -> {
                    println(result.data)
                    getTeams()
                    // Wait for teams to update and find the newly created team
                    onTeamCreated(result.data)
                }

                is Resource.Error -> {
                    errorText.value = result.text ?: stringResourcePlain(Res.string.unknown_error)
                    showPopUpError.value = true
                }
            }
        }
    }

    fun addNewSkill(skillName: String) {
        viewModelScope.launch {
            when (val result = repository.addSkill(
                Skills(
                    name = skillName,
                    workspaceId = repository.getWorkspaceId()
                )
            )) {
                is Resource.Success -> {
                    val response = result.data
                    if (response != null) {
                        init()
                        response.name?.let { newSkillName ->
                            val updatedSkills = selectedSkills.value + newSkillName
                            setSelectedSkills(updatedSkills)
                        }
                    }
                }

                is Resource.Error -> {
                    errorText.value = result.text ?: stringResourcePlain(Res.string.unknown_error)
                    showPopUpError.value = true
                }
            }
        }
    }

    fun getAllSkillsRemote() {
        repository.getToken().takeIf { it.isNotEmpty() }?.let {
            viewModelScope.launch {
                when (val result = repository.getSkillsByWorkspace()) {
                    is Resource.Success -> {
                        _availableSkills.value = result.data ?: emptyList()
                    }

                    is Resource.Error -> {
                        // Handle error state if needed
                    }
                }
            }
        }
    }

    fun getAllTeamsRemote() {
        viewModelScope.launch {
            when (val result = repository.getTeams()) {
                is Resource.Success -> {
                    result.data?.let { teamsList ->
                        _teams.value = teamsList
                    }
                }

                is Resource.Error -> {
                    // Handle error state if needed
                }
            }
        }
    }

    fun removeSkills() {
        viewModelScope.launch {
            _availableSkills.value = emptyList()
            _selectedSkills.value = emptyList()
        }
    }

    fun getUserById(userId: String) {
        if (userId.contains("profileSettings")) {
            val user = repository.getUser()
            user?._id = "profileSettings-${user?._id}"
            _selectedUser.value = user
        } else {
            viewModelScope.launch {
                repository.getUsersFlow().collect { users ->
                    val user = users.firstOrNull { it._id == userId }
                    _selectedUser.value = user
                }
            }
        }
    }

    fun findPlace(name: String) {
        viewModelScope.launch {
            val list = repository.findPlace(name)
            places.clear()
            places.addAll(list?.toList() ?: emptyList())
        }
    }

    fun isAdmin(): Boolean {
        return repository.getUser()?.role.equals(Role.admin.name, ignoreCase = true) ||
                repository.getUser()?.role.equals(Role.superAdmin.name, ignoreCase = true)
    }

    fun isManager(): Boolean {
        return repository.getUser()?.role.equals(Role.manager.name, ignoreCase = true)
    }

    fun isEmployee(): Boolean {
        return repository.getUser()?.role.equals(Role.employee.name, ignoreCase = true)
    }

    private fun validateRoleLimit(
        roleSelected: String?,
        onResult: (StringResource?) -> Unit
    ) {
        viewModelScope.launch {
            val users = repository.getUsersFlow().first()
            val currentUser = repository.getUser()
            val planId = currentUser?.planId
                ?: repository.getWorkspaceById(repository.getWorkspaceId())?.planId ?: ""
            val plan = repository.getPlan(planId)

            val activeUsers = users.filter { it.status == UserStatus.active.name }
            val usersMap = activeUsers.groupBy { it.role }

            var managerCount = usersMap[Role.manager.name]?.size ?: 0
            var employeeCount = usersMap[Role.employee.name]?.size ?: 0

            if (roleSelected == Role.employee.name && selectedUser.value?.role != roleSelected)
                employeeCount++
            else if (roleSelected == Role.manager.name && selectedUser.value?.role != roleSelected)
                managerCount++

            getRoleLimitErrorOrNull(roleSelected, managerCount, employeeCount, plan) { result ->
                onResult(result)
            }
        }
    }

    private fun getRoleLimitErrorOrNull(
        roleSelected: String?,
        managerCount: Int,
        employeeCount: Int,
        plan: Plan?,
        onResult: (StringResource?) -> Unit
    ) {
        val result = when (roleSelected) {
            Role.manager.name -> {
                if (managerCount > (plan?.limitManagers?.toInt() ?: Int.MAX_VALUE))
                    Res.string.error_manager_number
                else null
            }

            Role.employee.name -> {
                if (employeeCount > (plan?.limitUsers?.toInt() ?: Int.MAX_VALUE))
                    Res.string.error_employee_number
                else null
            }

            else -> null
        }
        onResult(result)
    }
}

